module.exports = __webpack_public_path__ + "static/media/centro-bazterrica.a8a9569f.svg";